module.exports = __webpack_public_path__ + "img/invitation-step-2.86a1eb50.svg";